// bootstrap mock, to be replaced with the bootstrap impelementation of the angular project for the magnolia-hosted configuration
